
window.hktheme.$ = jQuery.noConflict();

(function ($, hktheme) {

    function get_section_name(event) {
        var section = null;
        if (event && event.detail) {
            var data = {};
            var dataset = event.target.dataset;
            for (var key in dataset) {
                if (dataset.hasOwnProperty(key) && key.indexOf('themeEditorSection-') === 0) {
                    data = JSON.parse(dataset[key]);
                }
            }
            if (data.hasOwnProperty('type')) {
                section = data['type'];
            }
        }
        return section;
    }
    
    document.addEventListener('shopify:section:load', load_all);
    window.addEventListener("load", load_all);

    // Run the fade in animation as soon as possible, don't wait for full content load
    $(document).ready(function () {
        load_show_on_scroll();
    });

    function load_all(event) {
            
        var section = get_section_name(event);

        if (!section || section === 'video-hero') {
            load_youtube_section();
            load_vimeo_api();
        }

        if(!section || section === 'video-hero') {
            load_mp4_video_hero();
            header_height();
            $(window).off('resize', header_height).on('resize', header_height);
        }
    }

    // Show on scroll animation
    function load_show_on_scroll() {
        $(window).on('scroll', function () {
            show_on_scroll_checker();
        });
        show_on_scroll_checker();

        //new WOW().init();
    }

    function show_on_scroll_checker() {
        var window_height = $(window).height();
        $('.show-on-scroll').each(function (index, section) {
            var rect = section.getBoundingClientRect();
            if (rect.bottom >= 0 && rect.top < window_height) {
                $(section).removeClass('show-on-scroll').addClass('shown-on-scroll animated fadeInUp');
            }
        });
    }

    function load_mp4_video_hero() {
        if($('.hero-video-mp4').length) {
            window.Shopify.loadFeatures([
            {
                name: 'video-ui',
                version: '1.0',
                onLoad: function () {
                $('.hero-video--media').each(function (index, el) {
                    var mute = el.dataset.mute === 'true';
                    var autoplay = el.dataset.autoplay === 'true';
                    var loop = el.dataset.loop === 'true';
                    var hideControls = el.dataset.hideControls === 'true';
                    // Autoplay videos always need to be muted.
                    if(autoplay) {
                        mute = true;
                    }

                    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                        autoplay = false;
                    }

                    const plyrElement = $(el).find('.hero-video-mp4').get(0);

                    const player = new Shopify.Plyr(plyrElement, {
                        loop: {
                            active: loop,
                        },
                        autoplay: autoplay,
                        muted: mute,
                        fullscreen: {
                            enabled: false
                        }
                    });

                    player.on('ready', function (event) {
                        const instance = event.detail.plyr;

                        var customBtn = $(el).parent().find('.hero-video-play-button');

                        if(customBtn.length) {
                        registerVideoPlayButton(customBtn, 'plyr', instance, true);
                        }

                        if(hideControls) {
                        player.toggleControls(false);
                        }

                        // Autoplay if Save-Data is not set
                        if ("connection" in navigator) {
                            if (navigator.connection.saveData === false && autoplay) {
                                player.play();
                            }
                        }
                        else {
                            player.play();
                        }
                    });
                });
                }.bind(this),
            },
            ]);
        }
    }

    // Load Youtube, Vimeo
    function load_youtube(element, isVideoHero) {
        if(typeof isVideoHero == undefined) {
            isVideoHero = false;
        }
    
        if(isVideoHero) {
            var parentCont = $(element).closest('.hero-video--media').get(0);
            var autoplay = parentCont.dataset.autoplay === "true",
                mute = parentCont.dataset.mute === "true",
                loop = parentCont.dataset.loop === "true",
                hideControls = parentCont.dataset.hideControls === 'true';
                videoId = youtube_get_id(parentCont.dataset.videoid);
    
            if(autoplay) {
                mute = true;
            }
        }
        else {
            var autoplay = element.dataset.homepageHeroVideoAutoplay === "true",
                mute = element.dataset.homepageHeroVideoMute === "true",
                loop = element.dataset.homepageHeroVideoLoop === "true",
                videoId = element.dataset.homepageHeroVideoLink;
        }
    
        // Edge doesn't support prefers-reduced-motion, so always returns TRUE.
        if(navigator.appVersion.indexOf("Edge") !== -1) {
            if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                autoplay = false;
            }
        }
    
        var thisPlayer = false;
    
        player = new window.YT.Player(element.id, {
            videoId: videoId,
            playerVars: {
                showinfo: 0,
                modestbranding: 1,
                rel: 0,
                autoplay: autoplay ? 1 : 0,
                controls: hideControls ? 0 : 1,
                playlist: videoId,
                cc_load_policy: 0,
                fs: 0,
                iv_load_policy: 3,
                playsinline: 1,
                branding: 0,
                origin: window.location.origin
            },
            events: {
                onReady: function (event) {
                    youtube_heroes[element.id] = event.target;
                    var el = document.getElementById(element.id);
                    if (mute || autoplay) {
                        event.target.mute();
                    }
    
                    registerVideoPlayButton(el, 'youtube', event.target, isVideoHero);
    
                    var customBtn = $(parentCont).parent().find('.hero-video-play-button');
    
                    if(customBtn.length && isVideoHero) {
                        btnEl = customBtn.get(0);
                        registerVideoPlayButton(btnEl, 'youtube', event.target, isVideoHero);
                    }
    
                    // Prevent focus, it makes the video jump offscreen when the logo is focussed on.
                    $('.video-hero-youtube').attr('tabindex', -1);
    
                    // Autoplay if Save-Data is not set
                    if ("connection" in navigator) {
                        if (navigator.connection.saveData !== true && autoplay) {
                            event.target.playVideo();
                        }
                    }
                    else if (autoplay){
                        event.target.playVideo();
                    }
                },
                onStateChange: function (event) {
                    if (event.data === window.YT.PlayerState.PLAYING) {
                        if (!isVideoHero) {
                            hideVideoOverlays(element);
                        }
                        else {
                            $(parentCont).addClass('media-playing');
                        }
                    }
                    if (event.data === window.YT.PlayerState.ENDED && loop) {
                        youtube_heroes[element.id].seekTo(0);
                        youtube_heroes[element.id].playVideo();
                    }
                }
            }
        });
    }
    
    function load_youtube_all() {
        $('.homepage-hero-youtube-video').each(function (index, el) {
            load_youtube(el);
        });
        $('.video-hero-youtube').each(function (index, el) {
            load_youtube(el, true);
        });
    }
    
    var youtube_loaded_callbacks = [];
    var youtube_heroes = [];
    
    window.onYouTubePlayerAPIReady = function () {
        youtube_loaded_callbacks.forEach(function (callback) {
            callback();
        });
        youtube_loaded_callbacks.splice(0);
    };
    
    function load_youtube_api(force) {
        return new Promise(function (resolve) {
            if (window.YT) {
                // We already have youtube API loaded, call 'load_youtube_all'
                resolve();
            } else if (!document.querySelector('#youtube_api')) {
                // Resolve once youtube is loaded
                youtube_loaded_callbacks.push(resolve);
    
                // Youtube API is not yet loaded, create script that loads it
                create_script("youtube_api", "https://www.youtube.com/player_api");
            } else {
                // Script for loading youtube API is there, but youtube is not yet loaded
                youtube_loaded_callbacks.push(resolve);
            }
        });
    }
    
    function youtube_get_id(url){
    var ID = '';
    url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if(url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    }
    else {
        ID = url;
    }
        return ID;
    }
    
    function vimeo_get_id(url) {
    var regex = /(videos|video|channels|\.com)\/([\d]+)/;
    return url.match(regex)[2];
    }
    
    function load_youtube_section() {
        if (!document.querySelector('.homepage-hero-youtube-video') &&
            !document.querySelector('.video-hero-youtube')) {
            // No youtube elements, do not load youtube API
            return;
        }
    
        load_youtube_api().then(load_youtube_all);
    }
    
    function load_vimeo(element, isVideoHero) {
    
        if(typeof isVideoHero == undefined) {
            isVideoHero = false;
        }
    
        if(isVideoHero) {
            var parentCont = $(element).closest('.hero-video--media').get(0);
            var autoplay = parentCont.dataset.autoplay === "true",
                mute = parentCont.dataset.mute === "true",
                loop = parentCont.dataset.loop === "true",
                hideControls = parentCont.dataset.hideControls === 'true';
                videoId = vimeo_get_id(parentCont.dataset.videoid);
    
            if(autoplay) {
                mute = true;
            }
        }
        else {
            var autoplay = element.dataset.vimeoAutoplay === "true",
                mute = element.dataset.homepageHeroVideoMute === "true",
                loop = element.dataset.homepageHeroVideoLoop === "true",
                videoId = element.dataset.homepageHeroVideoLink;
        }
    
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            autoplay = false;
        }
    
        var player = new Vimeo.Player(element.id, {
            id: videoId,
            autoplay: autoplay ? true : false,
            controls: hideControls ? false : true
        });
    
        player.ready().then(function(){
            registerVideoPlayButton(element, 'vimeo', player, isVideoHero);
    
            var customBtn = $(parentCont).parent().find('.hero-video-play-button');
    
            if(isVideoHero) {
                if(mute || autoplay) {
                    player.setVolume(0);
                }
                if(loop) {
                    player.setLoop(true);
                }
                if(customBtn.length) {
                    btnEl = customBtn.get(0);
                    registerVideoPlayButton(btnEl, 'vimeo', player, isVideoHero);
                }
                // Autoplay if Save-Data is not set
                if ("connection" in navigator) {
                    if (navigator.connection.saveData === false && autoplay) {
                        player.play();
                    }
                }
                else {
                    player.play();
                }
            }
            else {
                if (document.querySelector('#' + element.id).dataset.vimeoAutoplay === "true") {
                    hideVideoOverlays(element);
                }
    
                if (document.querySelector('#' + element.id).dataset.homepageHeroVideoMute === "true") {
                    player.setVolume(0);
                }
            }
        }).catch(function (e) {
            document.getElementById(element.id).innerText = e;
        });
    }
    
    function load_vimeo_all() {
        $('.homepage-hero-vimeo-video').each(function (index, el) {
            load_vimeo(el);
        });
        $('.video-hero-vimeo').each(function (index, el) {
            load_vimeo(el, true);
        });
    }
    
    function load_vimeo_api() {
        if (!document.querySelector('.homepage-hero-vimeo-video') &&
            !document.querySelector('.video-hero-vimeo')) {
            // No Vimeo elements, do not load API
            return;
        }
    
        if (!document.querySelector('#vimeo_api')) {
            // Vimeo API is not yet loaded, create script that loads it
            var script = create_script("vimeo_api", "https://player.vimeo.com/api/player.js");
    
            if (script.readyState) {
                // IE
                script.onreadystatechange = function() {
                    if (element.readyState == "loaded" || element.readyState == "complete") {
                        element.onreadystatechange = null;
                        load_vimeo_all();
                    }
                };
            } else {
                // Other browsers
                script.onload = function() {
                    load_vimeo_all();
                };
            }
        } else if (!window.Vimeo) {
            // Script for loading vimeo API is there, but vimeo is not yet loaded,
            // load_vimeo_all will be called when script finishes loading
        } else {
            // We already have vimeo API loaded, call 'load_vimeo_all'
            load_vimeo_all();
        }
    }
    
    // register events on the video play button, plays video and hides certain elements.
    function registerVideoPlayButton(element, type, player, isVideoHero){
        if(typeof isVideoHero == undefined) {
            isVideoHero = false;
        }
    
        if(isVideoHero) {
            var videoParent = $(element).closest('.hero-video--wrapper').find('.hero-video--media');
            if (!videoParent) return;
            if($(element).is('button')) {
                var $playButton = $(element);
            }
            else {
                // You can click anywhere on the video to play/pause it.
                var $playButton = $(videoParent);
            }
        }
        else {
            var videoParent = element.closest('.homepage-hero-content--video');
            if (!videoParent) return;
            var $playButton = $(".homepage-video-play-button", videoParent);
    
            $playButton.off("keyup").on("keyup", function(event) {
                if(event.keyCode == 13 || event.keyCode == 32) {
                    videoTogglePlay(type, player, videoParent, isVideoHero);
                    event.stopImmediatePropagation();
                }
            });
    
            $playButton.off("click").on("click", function(event) {
                videoTogglePlay(type, player, videoParent, isVideoHero);
                event.stopImmediatePropagation();
            });
        }
    
    }
    
    function videoTogglePlay(type, player, videoParent, isVideoHero) {
        if(type === 'youtube') {
            if ($(videoParent).hasClass('media-playing')) {
                // Don't pause if autoplaying.
                if(typeof $(videoParent).data('autoplay') !== undefined) {
                    player.pauseVideo();
                    $(videoParent).removeClass('media-playing');
                }
            }
            else {
                player.playVideo();
            }
        } else if(type === 'vimeo') {
            player.getPaused().then(function(paused) {
            if(paused) {
                player.play();
            }
            else {
                player.pause();
            }
            });
        } else if(type === 'plyr') {
            player.togglePlay();
        }
        if(!isVideoHero) hideVideoOverlays(element);
    }
    
    function hideVideoOverlays(videoElement){
    
        var videoParent = videoElement.closest('.homepage-hero-content--video');
    
        $(".js__hide-on-play", videoParent).fadeOut(750);
    
        // Hide the ::before pseudo-element on the container when we press play.
        $('.homepage-hero-content-overlay-wrapper', videoParent).addClass('overlay-hidden');
    
    }

    function create_script(id, src) {
        var tag = document.createElement('script');
        tag.id = id;
        tag.src = src;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        return tag;
    }

    function header_height() {
        var announcementBar = $('#shopify-section-announcement-bar').height();
        var header = $('#shopify-section-header').height();
    
        var headerHeight = announcementBar + header;
        var nonOverlayHeight = announcementBar;
    
        // Subtract the announcement bar from the video height.
        if($('.desktop-height-fullscreen').length && $(window).width() >= 768) {
            if($('.overlay-header').length === 0) {
                $('.desktop-height-fullscreen').css('height', 'calc(100vh - ' + headerHeight + 'px)');
            }
            else {
                $('.desktop-height-fullscreen').css('height', 'calc(100vh - ' + nonOverlayHeight + 'px)');
            }
        }
        else if ($('.mobile-height-fullscreen').length && $(window).width() < 768) {
            if($('.overlay-header').length) {
                $('.mobile-height-fullscreen').css('height', 'calc(100vh - ' + announcementBar + 'px)');
            }
        }
        else {
            $('.hero-video').css('height', '');
        }
    }

})(window.hktheme.$, window.hktheme);


(function ($, hktheme) {
    var jQuery = $;

    // Hunabku functions
    window.hunabku = window.hunabku || {};
    hunabku.init = function () {
        hunabku.responsiveVideos();
    };

    hunabku.responsiveVideos = function () {
        var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

        $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if($(this).parents('.hero-video').length > 0) return;
            $(this).wrap('<div class="video-wrapper"></div>');
        });

        $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
        });
    };
    
    // Initialize Hunabku's JS on docready
    $(hunabku.init);
    document.addEventListener('shopify:section:load', hunabku.init); 

})(window.hktheme.$, window.hktheme);